import { parsePrintDispPresOption } from 'src/app/services/api-service/parameters/PRN001Params';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DosageDTO, HistApi } from 'src/app/services/api-service/hist/hist-api';
import { WholeHist } from 'src/app/services/api-service/hist/whole-hist';
import { UserCache } from 'src/app/services/user-cache';
import { Clinic } from 'src/app/system/clinic/models/clinic';
import * as QRCode from 'qrcode';
import { HcrService } from 'src/app/services/hcr-service.service';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { SessionService } from 'src/app/services/session.service';
import { HCASignRequestData } from 'src/app/shared/hcr-lib/HcaInitData';
import { HistEditOption } from 'src/app/services/api-service/hist/hist-edit-option';
import { HistService } from 'src/app/hist/services/hist.service';
import { RegisterApi } from 'src/app/services/api-service/register/register-api';
import { NHIRegIC } from 'src/app/services/api-service/register/nhiRegIc';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { HistOrder } from 'src/app/hist/models/hist-order';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { fixSpecialChar, isSpecialChar, NullOrEmptyTrim } from 'src/app/shared/utilities';
import { OrderDispensingTypeEnum } from 'src/app/enums/DispensingTypeEnum';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { RepeatedPrescriptionQRcode } from 'src/app/services/api-service/hist/whole-large-hist';
import { CidMaskPipe } from 'src/app/shared/pipes/cid-mask.pipe';
import { HistRxDispPresConst } from 'src/app/shared/constants/hist-rx-const';

/** 連續處方箋 */
@Component({
  selector: 'app-repeated-prescription',
  templateUrl: './repeated-prescription.component.html',
  styleUrls: ['./repeated-prescription.component.css'],
  providers: [CidMaskPipe]
})
export class RepeatedPrescriptionComponent implements OnInit {
  sizePage = {
    width: 21, //cm
    height: 29.7 //cm
  };
  a5hSizePage = {
    width: 21, //cm
    height: 14.8 //cm
  };
  a6SizePage = {
    width: 9.25, //cm
    height: 14 //cm
  };
  a6PaddingPage = {
    top: -0.5, //cm
    right: 0, //cm
    bottom: 0.2, //cm
    left: 0 //cm
  };
  @ViewChild('reportContainer')
  reportContainer: ElementRef<HTMLDivElement>;
  @ViewChild('reportContainerA6')
  reportContainerA6: ElementRef<HTMLDivElement>;

  hist: WholeHist;
  ic: NHIRegIC;
  clinic: Clinic;
  @ViewChild('qrcodeImg')
  qrcodeImg: ElementRef<HTMLImageElement>
  @ViewChild('qrcode2Img')
  qrcode2Img: ElementRef<HTMLImageElement>
  @ViewChild('qrcodeItreatnumImg')
  qrcodeItreatnumImg: ElementRef<HTMLImageElement>
  @ViewChild('qrcodeItreatnum2Img')
  qrcodeItreatnum2Img: ElementRef<HTMLImageElement>
  cidMask = '1234*****0';
  bitrhMask = 'YYY年MM月DD日';
  isopenQRcode = false;
  textToEncode = 'sadasdas233dasdADD';
  normalCheck: string = 'V';
  cntPresCheck: string = '';
  repeatprehcaModule: { InitModule: number, InitSession: number }
  medcodeName: string;
  regdateString: string;
  checkSeven = false;
  isPrintItreatnum = true;
  isPrintRegDateTime = true;
  isPrintQRCode = true;
  isPrintBarcode = true;

  get isPrintAnyDispPresOption(): boolean {
    return this.isPrintItreatnum || this.isPrintRegDateTime || this.isPrintQRCode || this.isPrintBarcode;
  }

  sevenHRx: HistOrder[] = [];
  /** 須單獨成張的醫令，於 getHtml 尾端另外輸出一張；僅非慢箋會有值 */
  specialHRx: HistOrder[] = [];
  pageHRx: HistOrder[][] = [];
  fontType: string;
  printRxType: number[] = [];
  isA5h = false;
  isA6 = false;
  multiPage = false;
  unDisplayPPartRx = true;
  IsPrintAfterSevenDispPrescription: boolean = true;
  isPrintDispPresClinic: boolean = false;
  /** 是否為藥局 */
  isPharm = UserCache.getLoginUser().Clinic.TypeIsPharmacy;

  @Input()
  set regId(id) {
    this.setRegId(id);
  }
  constructor(private api: HistApi,
    private regApi: RegisterApi,
    private cdr: ChangeDetectorRef,
    private hcrService: HcrService,
    private histService: HistService,
    private notification: EasyNotificationService,
    private sessionService: SessionService,
    private cidMaskPipe: CidMaskPipe,
    private clinicDataService: ClinicDataService
  ) {
  }
  get editOptions(): HistEditOption {
    return this.histService.EditOptions;
  }
  get dosages(): DosageDTO[] {
    return this.editOptions.dosage;
  }
  async getQRCode(): Promise<boolean> {
    try {

      this.certStr = await this.histService.GetHCACert();

      return true;
    }
    catch (ex) {
      return false;
    }
  }
  async ngOnInit() {

    var st = document.createElement('style');
    st.appendChild(document.createTextNode(
      '@media print {margin: 0; page-break-inside: avoid; break-inside: avoid;\n' +
      'body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.pres-report table{ border:1px solid black; border-collapse: collapse; }\n' +
      '.pres-report table td, table th { border: 1px solid black; padding-left: 2px;padding-right: 2px;}\n' +
      '.pres-report table tr:first-child th { border-top: 0; }\n' +
      '.pres-report table tr:last-child td { border-bottom: 0; }\n' +
      '.pres-report table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
      '.pres-report table tr td:last-child, table tr th:last-child { border-right: 0; }'
    ));
    setTimeout(() => {
      this.reportContainer.nativeElement.appendChild(st);
      this.reportContainerA6.nativeElement.appendChild(st);

    }, 0);
    st.outerHTML

  }
  cid = '';
  doctorCid = '';
  birthday = '';
  backRegDate: string;
  deadLine: string;
  StartStr: string[] = ['', '', '', ''];
  EndStr: string[] = ['', '', '', ''];
  NoNeedPart: string[] = ['001', '002', '003', '004', '005', '006', '007', '008', '009',
    '012', '013', '801', '802', '901', '902', '903', '904', '905',
    '906', '907', '908', '909', '910', '911', '912', '913', '914'];

  isNoNeedPartCode(code: string): boolean {
    return this.NoNeedPart.includes((code ?? '').trim());
  }

  async setRegId(regId: number, currentPres: number = null) {
    // 處方籤 A4 or A6 Type
    var param = await this.clinicDataService.getParam("PRN001");
    this.isA6 = param?.RepeatPresType == 2;
    this.isA5h = param?.RepeatPresType == 3;

    this.IsPrintAfterSevenDispPrescription = param?.IsPrintAfterSevenDispPrescription ?? true;

    this.isPrintDispPresClinic = param?.IsPrintDispPresClinic ?? false; // 是否列印自調藥參數
    var useOutVisit = this.sessionService.getData('useOutVisit');
    var useOutVisitJail = this.sessionService.getData('useOutVisitJail');
    var additionPrintSetting = this.sessionService.getData('additionPrintSetting');
    var hcaModule = this.sessionService.getData('hcaModule');

    if (useOutVisit || useOutVisitJail) {
      if (additionPrintSetting) {
        var paramArr: ValueTextPair[] = [];
        var oriParam = additionPrintSetting.replace(/\ /g, '').replace(/\{/g, '').replace(/\}/g, '').replace(/\"/g, '');
        const strs = oriParam.split(',');
        strs.forEach(str => {
          const data = new ValueTextPair();
          if (str.indexOf(':') > 0) {
            data.text = str.split(':')[0];
            data.value = str.split(':')[1];
          } else {
            data.text = str;
            data.value = str;
          }
          paramArr.push(data);
        });
        var type = Number(paramArr.find(x => x.text == 'RepeatPresType').value);
        if (type) {
          this.isA6 = type == 2;
          this.isA5h = type == 3;
        }
      }
    }

    var param2 = await this.clinicDataService.getParam("DRG002");
    this.printRxType = param2?.RxOrderType;
    this.StartStr = ['', '', '', ''];
    this.EndStr = ['', '', '', ''];
    this.clinic = UserCache.getLoginUser().Clinic;
    let userCId = UserCache.getLoginUser().CId;
    let userName = UserCache.getLoginUser().Name;
    let wholeHist = await this.api.getRepeatedPrescription(regId, this.signStr, this.clinic, userCId, userName, this.isopenQRcode, true);
    this.hist = wholeHist.WholeHist;
    this.unDisplayPPartRx = this.NoNeedPart.some(x => x == this.hist.Hist.ApartCode) || this.hist.Register.ICode == '000';  // 自費診不顯示高藥費
    var nFilter = wholeHist.NFilter;

    this.hist.Hist.HRxs = this.hist.Hist.HRxs.filter(x =>
      !nFilter.includes(x.SPRule)
      || x.RxCode == '/7');
    if (this.hist && !isNaN(this.hist?.Hist?.PPartRx)) this.hist.Hist.PPartRx = Math.abs(this.hist?.Hist.PPartRx);
    if (this.hist && this.isPharm && !isNaN(this.hist?.Hist?.APartRx)) this.hist.Hist.APartRx = Math.abs(this.hist?.Hist.APartRx);
    this.ic = wholeHist.NHIRegIC;
    //有發生案例是就醫識別碼中有特殊字元，所以要處理，不然會造成BarCode印製失敗。
    //案例: g  F128Y9S3BCQCWC\u0000\u0000\u0000
    if (isSpecialChar(this.ic.Itreatnum)) {
      this.ic.Itreatnum = fixSpecialChar(this.ic.Itreatnum);
    }
    let ispres = this.hist.Hist.CntPresTot != '' && this.hist.Hist.CntPresTot != null && this.hist.Hist.CntPresTot != undefined;
    if (ispres) {
      if (this.hist.Hist.CusNo == '1' && this.hist.Register.ICode != '000') this.unDisplayPPartRx = true; //連處第一次不顯示高藥價提示
      this.backRegDate = '　回診日：' + DateHelper.formatROCDate(wholeHist.BackRegDate, false);
      this.deadLine = '　截止日：' + DateHelper.formatROCDate(wholeHist.Deadline, false);
      if (wholeHist.PresDateStartAndEnds?.length > 0) {
        for (var i = 0; i < wholeHist.PresDateStartAndEnds.length; i++) {
          var pre = wholeHist.PresDateStartAndEnds.find(x => x.CntPresNo == (i + 1));
          var start = DateHelper.getFormatedDateString(pre?.StartDate, true);
          var firstReg = DateHelper.getFormatedDateString(wholeHist.FirstRegDate, true);
          if (i == 0) start = firstReg;
          var end = DateHelper.getFormatedDateString(pre?.EndDate, true);
          if (pre?.EndDate) this.StartStr[i] = start + '~'
          else this.StartStr[i] = start;
          this.EndStr[i] = end;
        }

        if (currentPres > 0) {

          this.StartStr = [this.StartStr[currentPres - 1]];
          this.EndStr = [this.EndStr[currentPres - 1]];

        }
      }
    } else {
      this.backRegDate = '';
      this.deadLine = '';
    }
    var doctorICSqno = '';
    var aesKey = '';
    var samId = '';
    var hospId = '';
    // var samId = "001000005284"; //測試用
    var request = new HCASignRequestData();
    request.QRCodeData = wholeHist.Data;
    request.InitModule = hcaModule?.InitModule;
    request.InitSession = hcaModule?.InitSession;
    console.log('InitSession', request)
    if (this.isopenQRcode) {
      hospId = (await this.hcrService.VisionApi.GetHospID())?.Data;
      var samNo = await this.hcrService.VisionApi.GetCardNoSAM();
      samId = samNo?.Data;
      console.log('處方箋samNo', samNo?.Data)
      //測試用
      // this.signStr = "2597D7E5CBEA5A92C5C35442FA89312131022746093A00A8ECC7FC1F5B42CB49DE8DEBD22840FC409A314FC33AD35BA0776A00D2C51F8DAE515D290F826F0533D2A721C335DBF3BEE318971A68A857ECFFE1BC816C56904826CFE6E80234C5AFD0E95B4064A976554466A738A2E6CF6D335600A48D89BA240F177DCD5E7D1A9655AF214A25A1A8B9715EAAF328E524BA1E55451A248EB638B9255039BAE834E7FBBDEAF6F4FBA35774B0C5CCF5400236601D516FD4C09B8F52EAD42C0C3A65A286E1154D02AD97AEBC311076DB35B0DF10777A074AEBB4FAB1ECD097C934DBE5DA2A0F47A4227275C35555EA1E46E9F381A0FA83709750A69498E8A665BA1D52";
      this.signStr = '';
      if (request.InitSession > 0) {
        var sign = await this.hcrService.VisionApi.GetHCASign(request);
        console.log('處方箋SignData', sign)
        this.signStr = sign?.Data;
      }

      if (NullOrEmptyTrim(this.signStr)) {
        this.notification.showError(`取[簽章S]失敗!`);
        return
      }

      let regedit = await this.regApi.GetEditOptions();
      let medcode = this.hist.Register.MedDeptCode.toString();
      this.medcodeName = regedit?.section.find(x => x.value == medcode)?.text || medcode;
      this.regdateString = this.dateString(this.hist?.Register.RegDate);
      this.certStr = await this.histService.GetHCACert();  // 取醫師憑證序號
      doctorICSqno = this.certStr || '';
      var signKey = '';
      var randomKey = '';
      aesKey = '';
      var getKeyRandom = await this.hcrService.VisionApi.GetVPNGetRandomXAndSignX('3', '26');
      if (getKeyRandom?.Data) {
        signKey = getKeyRandom.Data.SignX
        randomKey = getKeyRandom.Data.RandomX;
      }
      if (!NullOrEmptyTrim(signKey) && !NullOrEmptyTrim(randomKey)) {
        var queryObj = {
          "sHospId": hospId,
          "sClientRandom": randomKey,
          "sSignature": signKey,
          "sSamId": samId,
        }
        console.log('處方箋取Key Response', queryObj)
        var retQuery = await this.hcrService.SendFromUrl('https://medws.nhi.gov.tw/api/irie4000/QryFileKeyValue',
          JSON.stringify(queryObj), 'application/json', '', {}
        )
        console.log('retQuery', retQuery);
        if (retQuery.Successed && retQuery.Returns) {
          var returnsObj = JSON.parse(retQuery.Returns);
          aesKey = returnsObj?.sKey || aesKey;
          if (NullOrEmptyTrim(aesKey)) {
            this.notification.showError(`取[Aeskey]失敗!`);
            return;
          }
        }
      }
      else {
        this.notification.showError('取Aeskey前置作業失敗!');
        return;
      }
    }
    var prescriptData = new RepeatedPrescriptionQRcode();
    prescriptData.Data = [];
    prescriptData.SignData = null;
    if (!NullOrEmptyTrim(this.signStr)) {
      var shortSign = this.signStr;
      prescriptData = await this.api.GetRepeatedPrescriptSignAndData(shortSign, wholeHist.Data, doctorICSqno, aesKey, false);  // 產生CSD時不再做Brotli壓縮
    }

    if (ispres) {
      this.normalCheck = '';
      this.cntPresCheck = 'V';
      this.checkSeven = this.hist.Hist.HRxs.some(x => x.RxCode == '/7');
    } else {
      this.normalCheck = 'V';
      this.cntPresCheck = '';
      this.checkSeven = false;
    }
    this.specialHRx = [];
    if (this.checkSeven) {
      let newhrx: HistOrder[] = [];
      for (var i = 0; i < this.hist.Hist.HRxs.length; i++) {
        if (this.hist.Hist.HRxs[i].RxCode == '/7') break;
        newhrx.push(this.hist.Hist.HRxs[i]);
      }
      let ids = newhrx.map(x => x.Id);
      this.sevenHRx = this.hist.Hist.HRxs.filter(x => !ids.includes(x.Id) && this.printRxType.indexOf(x.RxType) >= 0 && x.RxCode != '/7' && (this.isPharm || this.isPrintDispPresClinic || x.DispTP !== OrderDispensingTypeEnum.T0_Clinic));
      let hrxs = newhrx.filter(x => this.printRxType.indexOf(x.RxType) >= 0);
      this.hist.Hist.HRxs = this.hrxsToPage(hrxs);
    } else {
      //當筆數超過N筆時，印到第二頁
      let hrxs = this.hist.Hist.HRxs.filter(x => this.printRxType.indexOf(x.RxType) >= 0);
      if (!ispres) {
        if (!this.isPharm && !this.isPrintDispPresClinic) {
          hrxs = hrxs.filter(x => x.DispTP !== OrderDispensingTypeEnum.T0_Clinic);
        }
        hrxs = this.takeSpecialHRx(hrxs);
      }
      this.hist.Hist.HRxs = this.hrxsToPage(hrxs);
    }
    console.log('prescriptData', prescriptData);
    this.signData = prescriptData.SignData;
    if (!NullOrEmptyTrim(prescriptData?.Data[0])) {
      for (var i = 0; i < prescriptData.Data.length; i++) {
        var dSeq = 'D' + (i + 2);
        this.otherqrData.push('{\"' + dSeq + '\": \"' + prescriptData?.Data[i] + '\"}');
      }
    }
    var param = await this.clinicDataService.getParam("PRN001");
    this.cidMask = param.IDHidePRN ?? this.cidMask;
    this.bitrhMask = param.BirthdayHidePRN ?? this.bitrhMask;
    this.cid = this.hist?.Patient?.CId ? this.cidMaskPipe.transform(this.hist?.Patient?.CId, this.cidMask) : this.hist?.Patient?.CId;
    this.doctorCid = this.hist?.Hist.DoctorCId ? this.cidMaskPipe.transform(this.hist?.Hist.DoctorCId, this.cidMask) : this.hist?.Hist.DoctorCId;
    this.birthday = this.hist?.Patient?.Birthday ? DateHelper.getROCFullDateString(new Date(this.hist?.Patient?.Birthday)) : '';
    const printOption = parsePrintDispPresOption(param?.PrintDispPresOption);
    this.isPrintItreatnum = printOption.Itreatnum;
    this.isPrintRegDateTime = printOption.RegDateTime;
    this.isPrintQRCode = printOption.QRCode;
    this.isPrintBarcode = printOption.Barcode;
    this.fontType = (param.FontTypeForPrint == 0 ? '細明體' : (param.FontTypeForPrint == 1 ? '標楷體' : (param.FontTypeForPrint == 2 ? '微軟正黑體' : '細明體')));
  }
  /** 自 hrxs 抽出須單獨成張的醫令，回傳剩餘清單
   *  僅非慢箋病歷呼叫，慢箋(含 /7 切分)不做此處理。
   *  抽出後 hrxs 會變空時不抽：整張本來就只有該醫令，不需再切。
   */
  takeSpecialHRx(hrxs: HistOrder[]): HistOrder[] {
    var matched = hrxs.filter(x => HistRxDispPresConst.is單獨列印(x.StdCode));
    if (matched.length == 0 || matched.length == hrxs.length) {
      return hrxs;
    }
    this.specialHRx = matched;
    return hrxs.filter(x => !HistRxDispPresConst.is單獨列印(x.StdCode));
  }
  getHtml() {
    if (this.hist && this.clinic && this.isopenQRcode) {
      this.generateQRCode(this.signData, 1);
      if (this.otherqrData) {
        for (var i = 0; i < this.otherqrData.length; i++) {
          this.generateQRCode(this.otherqrData[i], 2);
        }
      }
    }

    if (this.ic && (this.isPharm ? this.ic.ItreatnumOri : this.ic.Itreatnum)) {
      this.generateQRCode((this.isPharm ? this.ic?.ItreatnumOri : this.ic?.Itreatnum), 3);
    }

    let report = this.isA6 ? this.reportContainerA6 : this.reportContainer;
    var html = report.nativeElement.innerHTML;
    if (this.multiPage) {
      this.pageHRx.forEach((hrx, idx) => {
        //上面已有第一頁，所以從第二頁開始
        if (idx > 0) {
          this.hist.Hist.HRxs = hrx;
          this.cdr.detectChanges();
          html = html + report.nativeElement.innerHTML;
        }
      });
    }
    if (this.checkSeven && this.sevenHRx.length > 0 && this.IsPrintAfterSevenDispPrescription && this.regApi.isPrintSeven && (this.isPharm || this.isPrintDispPresClinic || this.hist.Hist.DispTP != OrderDispensingTypeEnum.T0_Clinic)) {
      this.normalCheck = 'V';
      this.cntPresCheck = '';
      this.StartStr = ['', '', '', ''];
      this.EndStr = ['', '', '', ''];
      this.backRegDate = '';
      this.deadLine = '';
      this.hist.Hist.HRxs = this.sevenHRx;
      this.hist.Hist.CntPresTot = '';
      this.cdr.detectChanges();
      html = html + report.nativeElement.innerHTML;
    }
    // 單獨成張的醫令；僅非慢箋會有值，表頭欄位本就是一般處方狀態
    if (this.specialHRx.length > 0) {
      this.hist.Hist.HRxs = this.specialHRx;
      this.cdr.detectChanges();
      html = html + report.nativeElement.innerHTML;
    }
    return html;
  }
  generateQRCode(text: string, type: number): void {
    QRCode.toDataURL(text, (err, url) => {
      if (err) {
        console.error(err);
        return;
      }
      // 將產生的 QR Code 圖片網址存到變數中，或直接在範本中使用
      switch (type) {
        // 病歷
        case 1:
          this.qrcodeImg.nativeElement.src = url;
          break;
        //收據
        case 2:
          this.qrcode2Img.nativeElement.src = url;
          break;
        //就醫識別碼
        case 3:
          this.qrcodeItreatnumImg.nativeElement.src = url;
          this.qrcodeItreatnum2Img.nativeElement.src = url;
          break;
        //連處
        default:
          break;
      }
    });
  }
  certStr: string;
  signStr: string;
  signData: string;
  otherqrData: string[] = [];

  dateString(input: Date): string {
    var d = new Date(input);
    var month = (d.getMonth() + 1);
    var day = d.getDate();
    var year = d.getFullYear();
    return year + '/' + month + '/' + day;
  }
  get dxNames() {
    return [this.hist?.Hist.Dx1Name, this.hist?.Hist.Dx2Name, this.hist?.Hist.Dx3Name,
    this.hist?.Hist.Dx4Name, this.hist?.Hist.Dx5Name, this.hist?.Hist.Dx6Name].filter(x => x).join(',');
  }
  get dxCodes() {
    return [this.hist?.Hist.Dx1, this.hist?.Hist.Dx2, this.hist?.Hist.Dx3,
    this.hist?.Hist.Dx4, this.hist?.Hist.Dx5, this.hist?.Hist.Dx6].filter(x => x).join(',');
  }

  stringFactory(src: string, maxlength: number): string {
    if (src == null || src == '' || src == undefined) return ''      // 使用正規表達式匹配中文字符
    const chineseCharacters = src.match(/[\u4e00-\u9fa5]/g);
    const fullWidthPattern = /[\uFF01-\uFF60\uFFE0-\uFFE6]/g;

    let initlength = 0;
    // 如果沒有中文字符，則返回整個字串的長度
    for (let ind = 0; ind < src.length; ind++) {
      let chineseAlpha = src[ind].match(/[\u4e00-\u9fa5]/g);
      let fullWidthAlpha = src[ind].match(/[\uFF01-\uFF60\uFFE0-\uFFE6]/g);
      if (chineseAlpha) initlength += 2;
      else if (fullWidthAlpha) initlength += 2;
      else initlength += 1;
      if (initlength >= maxlength) {
        return src.substr(0, ind) + '..';
      }
    }
    return src;

  }

  getLimitCountPerPage() {
    //每頁限制筆數
    if (this.isA6) {
      //A6 (是否印就醫識別碼)
      return this.isPrintAnyDispPresOption ? 5 : 10;
    } else if (this.isA5h) {
      //A5橫式 (是否印就醫識別碼)
      return this.isPrintAnyDispPresOption ? 4 : 9;
    } else {
      //A4 (是否印就醫識別碼)
      return this.isPrintAnyDispPresOption ? 45 : 50;
    }
  }

  hrxsToPage(hrxs: HistOrder[]): HistOrder[] {
    //決定是否分頁multiPage，並將資料分頁pageHRx
    let limit = this.getLimitCountPerPage();
    let firstPage: HistOrder[] = [];
    this.multiPage = hrxs.length > 0 && hrxs.length > limit;
    if (this.multiPage) {
      this.pageHRx = hrxs.reduce((acc, cur, idx) => {
        const pageIndex = Math.floor(idx / limit);
        if (!acc[pageIndex]) {
          acc[pageIndex] = [];
        }
        acc[pageIndex].push(cur);
        return acc;
      }, []);
      firstPage = this.pageHRx[0];
    } else {
      firstPage = hrxs;
    }
    return firstPage;
  }
}
